var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-excel',{staticClass:"export_btn",attrs:{"type":"csv","footer":`Township : ${_vm.admin.township.name}`,"name":`Volunteer List (${_vm.admin.township.name}).xls`,"fields":_vm.custom_fields,"fetch":_vm.getData}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v("mdi-chevron-right-circle-outline")]),_vm._v("Export ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }